// @flow

import { useDispatch } from 'react-redux';

import { createLogger } from 'redux-logger';

import {
  upsertCartProduct,
  getCart,
  selectCartIsWorking,
  type DecoratedProduct,
} from '@gandi/cart';

import { useAppSelector } from 'src/hooks';

const logger = createLogger('useAddCartMailboxes');

export function useUpsertCartMailboxes(): {
  handleUpsertCartMailboxes: (
    payload: DecoratedProduct['payload'],
    productId?: string | number,
  ) => Promise<void>,
  isAddingMailboxes: boolean,
} {
  const dispatch = useDispatch();

  const isAddingMailboxes = useAppSelector(selectCartIsWorking);

  async function handleUpsertCartMailboxes(
    payload: DecoratedProduct['payload'],
    productId?: string | number,
  ) {
    try {
      await dispatch(
        upsertCartProduct({
          extra: {},
          options: {
            headers: { 'X-Dry-Run': 0 },
          },
          productData: {
            product_type: 'mailbox-standalone',
            process: 'create',
            payload,
          },
          productId,
        }),
      );
      dispatch(getCart());
    } catch (err) {
      dispatch(logger.warn({ err }, 'Unable to add mailboxes into the cart.'));
      throw err;
    }
  }

  return { handleUpsertCartMailboxes, isAddingMailboxes };
}
